// extracted by mini-css-extract-plugin
export default {"cover":"Vehicle_cover__35JeG","Badge":"Vehicle_Badge__wfAdD","react-datepicker-wrapper":"Vehicle_react-datepicker-wrapper__S0W1L"};